module.exports = __webpack_public_path__ + "img/snowflake-hrnek-2.ec2dc015.png";